<template>
  <div class="h-full flex flex-row items-center justify-center gap-4">
    <button :disabled="couponPoints === points[0]" @click="decreasePoints" style="background: #E17D7D;" class="points-input-button">
      <feather-icon icon="MinusIcon" class="button_icon" />
    </button>
    <p class="points-input" dir="ltr">{{ couponPoints || 0 }}</p>
    <button :disabled="couponPoints === points[points.length - 1]" @click="increasePoints" style="background: #85CD5F;" class="points-input-button">
      <feather-icon icon="PlusIcon" class="button_icon" />
    </button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "CouponManagementInputCell",
  data() {
    return {
      couponPoints: 0,
      points: [],
      task: null,
    };
  },
  methods: {
    updatePoints(payload) {
      this.params.updatePoints(payload);
    },
    decreasePoints() {
      let _point = this.couponPoints;
      const currentIndex = this.points.findIndex(point => point === this.couponPoints);
      if (currentIndex > 0) {
        _point = this.points[currentIndex - 1];
        this.couponPoints = _point;
      }
      this.updatePoints({
        id: this.params.value.volunteer.id,
        point: _point,
        type: _point > 0 ? 'negative' : 'positive',
      });
    },
    increasePoints() {
      let _point = this.couponPoints;
      const currentIndex = this.points.findIndex(point => point === this.couponPoints);
      if (currentIndex < this.points.length - 1) {
        _point = this.points[currentIndex + 1];
        this.couponPoints = _point;
      }
      this.updatePoints({
        id: this.params.value.volunteer.id,
        point: _point,
        type: _point > 0 ? 'positive' : 'negative',
      });
    },
    initializeCell() {
      // Get task data
      const _task = this.params.getTask();
      this.task = _task;
      // this.couponPoints = _task.couponPoints;

      // Initialize points array
      this.points = [
        _task.deductCouponPoints,
        0,
        _task.couponPoints,
      ].filter(point => point !== null && point !== undefined);

      // Get current volunteer ID
      const currentVolunteerId = this.params.value.volunteer.id;

      // Check if there's a saved point value for this volunteer
      // If yes, use it; otherwise, use the default from task
      const savedPoint = this.params.getSavedPoint ? this.params.getSavedPoint(currentVolunteerId) : null;
      this.couponPoints = savedPoint !== null ? savedPoint : _task.couponPoints;
    },
    // AG Grid calls this method when the cell needs to be refreshed (e.g., when scrolling)
    refresh(params) {
      // Update params reference
      this.params = params;

      // Re-initialize the cell with current row data
      this.initializeCell();

      // Return true to indicate the refresh was handled
      return true;
    },
  },
  created() {
    this.initializeCell();
  },
});
</script>

<style scoped>
.points-input-button {
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.points-input {
  text-align: center;
  font-size: 1.2rem;
  background: #fff;
  border: 1px solid #CACACA;
  border-radius: 8px;
  padding: 0px 50px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>